<template>

	<section v-if="options">

		<section class="col-12 margin-b-150">

			<form class="col-12">

				<label>Søg efter tilvalg</label>

				<section class="search">

<!--					<input class="col-12" type="text" name="name" placeholder="Hvad er navnet på tilvalget?" v-model="text">

					<button class="btn btn&#45;&#45;md btn&#45;&#45;primary primary&#45;&#45;copper" @click.prevent="doSearch">

						<span>Søg</span>

					</button>-->

                    <VueFuse
                        class="col-12"
                        :list="optionsFiltered"
                        :default-all="true"
                        placeholder="Hvad er navnet på tilvalget'?"
                        :fuse-opts="searchOptions"
                        :map-results="true"
                        @fuse-results="handleResults"></VueFuse>

				</section>

			</form>

		</section>

		<section class="data-list">

			<header class="col-12 margin-b-50">

				<h1>Oversigt</h1>

			</header>

			<transition-group name="fade" mode="out-in">

				<section class="item" v-for="option in results" :key="option.id">

					<section class="icon">

						<i class="icon--lg fas fa-shopping-bag"></i>

					</section>

					<section class="content">

						<h1 v-text="option.title"></h1>

						<ul>
							<li v-if="option.active">Status: Aktiv</li>
							<li v-else>Status: Inaktiv</li>
							<li>Pris: {{stripeAmount(option.price).amount}},-</li>
						</ul>

                        <ul class="products">
                            <template v-for="(product, index) in option.products">
                                <li>{{product.title}}</li>
                            </template>
                        </ul>

					</section>

					<section class="link">

						<a href="#" @click.prevent="addOption(option)">Tilføj</a>

					</section>

				</section>

			</transition-group>

		</section>

	</section>

</template>

<script>
    import {mapGetters} from 'vuex';
    import VueFuse from 'vue-fuse';
    export default {
        name: "option-index",
		props:['selectionOptions'],
        data(){
            return {
                text:'',
                searchOptions: {
                    keys:['title']
                },
                results:[],
            }
        },
        components:{
            VueFuse,
        },
        computed:{
            ...mapGetters({options:'options'}),
            optionIds(){
                return this.options.map(option => option.id);
            },
            optionsFiltered(){
                return this.options.filter(item => {
                    let filter = (this.optionIds.includes(`${item.id}`) || this.optionIds.includes(item.id)) && item.active;
                    if(filter && this.selectionOptions){
                        filter = !this.selectionOptions.includes(item.id);
                    }
                    return filter;
                })
            }
        },
        methods:{
            handleResults (r) {
                this.results = r
            },
			addOption(option){
                this.$emit('selected', option);
			}
        },
        created(){
            this.$store.dispatch('getOptions');
        }
    }
</script>
